import { queryOptions, useQuery } from '@tanstack/react-query'

import { storage, STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

import { authApi } from '../api/authApi'
import type { TMe } from '../models/auth.types'
import { authTokenStorage } from '../utils/authTokenStorage'
import { getIsLoggedIn } from '../utils/getIsLoggedIn'

export const getMeFromStorage = () => {
  const data = JSON.parse(storage.getItem(STORAGE_KEYS.ME) || 'null') || undefined
  const token = authTokenStorage.getToken()

  if (!data || !data.id || !token || !data.mailDeliveryIssues || !data.favoritePrayer) {
    return undefined
  }
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- validated JSON.parse result
  return { ...data, token } as TMe
}

export const getMeQueryOptions = () =>
  queryOptions({
    queryKey: ['me'],
    queryFn: ({ signal }) => authApi.getMe({ signal }),
    retry: 1,
    retryOnMount: true,
    retryDelay: 1000 * 60 * 3,
    staleTime: 60 * 1000,
    enabled: getIsLoggedIn(),
    // @ts-expect-error -- initialData is not typed correctly
    initialData: getMeFromStorage,
    initialDataUpdatedAt: 0, // Force initial data to be fetched immediately
  })

export const useMeQuery = () => useQuery(getMeQueryOptions())
